export const iconFontAwesomeSecurityShieldDog = (
	<i className="fa-solid fa-shield-dog"></i>
);
